import React from 'react';
import { css } from '@emotion/react';
import { useChatPlayContext } from '@provider/ChatPlayProvider';
import { MBTI_STORY_ID } from '@common/values';
import CharacterProfilePopup from '@components/commons/popup/CharacterProfilePopup';

import EndingPopup from '../ending/EndingPopup';
import AchievementPopup from '../popup/AchievementPopup';
import TTSGuide from '../popup/TTSGuide';
import ChoiceStatistics from './chatItem/choice/ChoiceStatisticsPopup';
import FullScreenEffect from './chatItem/FullScreenEffect';
import FullScreenImagePopup from './chatItem/FullScreenImagePopup';

const ChatPopups = () => {
  const {
    storyItems,
    badgesAcquired,
    endingPopupInfo,
    choiceStatistics,
    characterProfile,
    onShowCharacterProfile,
    onConfirmPopup,
    oncloseChoiceStatistics,
    fullScreenEffectInfo,
  } = useChatPlayContext();

  return (
    <>
      {storyItems && (
        <AchievementPopup
          storyItems={storyItems}
          onConfirm={() => onConfirmPopup('item')}
        />
      )}
      {badgesAcquired && (
        <AchievementPopup
          badgesAcquired={badgesAcquired}
          onConfirm={() => onConfirmPopup('achievement')}
        />
      )}
      {endingPopupInfo?.isShow && endingPopupInfo?.ending?.isFinal && (
        <EndingPopup
          ending={endingPopupInfo}
          onClose={() => onConfirmPopup('ending')}
          isShowButton={endingPopupInfo.ending.story?.storyId === MBTI_STORY_ID}
        />
      )}
      {choiceStatistics && (
        <div css={choiceStatisticsStyle}>
          <ChoiceStatistics
            choiceStatistics={choiceStatistics}
            onClose={() => {
              oncloseChoiceStatistics();
            }}
          />
        </div>
      )}
      <CharacterProfilePopup
        characterProfile={characterProfile}
        isShow={!!characterProfile}
        onClose={() => {
          onShowCharacterProfile(undefined);
        }}
      />
      <TTSGuide />
      {fullScreenEffectInfo && (
        <FullScreenEffect statement={fullScreenEffectInfo} />
      )}
      <FullScreenImagePopup />
    </>
  );
};

const choiceStatisticsStyle = css`
  width: 100%;
  max-width: 50em;
  height: 100%;
  position: fixed;
  z-index: 20;
`;

export default ChatPopups;
